import React, { Component, Fragment } from 'react';

import Content from "../../../components/Content/ContentPage/Content";
import ContentHeader from "../../../components/Content/ContentHeader/ContentHeader";
import Card from "../../../components/Card/Card";
import MessageHandler from "../../../components/MessageHandler/MessageHandler";
import ErrorHandler from "../../../components/ErrorHandler/ErrorHandler";
import Image from '../../../components/Image/Image';
import Loader from "../../../components/Loader/Loader";
import { dateOnlyReadable , dateTimeOnlyReadable} from "../../../util/dateTime";

import './SingleOrder.css';

class SingleOrder extends Component {
  state = {
    loadedOrderDetail: {},
    activeTab: true,
    minmaxdetail: false,
    orderDetailLoading: true
  };

  componentDidMount() {
    console.log(this.props.match.params.orderCode);
    const orderCode = this.props.match.params.orderCode;
    const graphqlQuery = {
      query: `query FetchSingleOrder($orderCode: Int!) {
          order(orderCode: $orderCode) {
            id
            code
            shipping_cost
            total_price
            discount
            order_date
            delivery_date
            status
            shipment_delivery_code
            lat
            lng
            state_id
            city_id
            district_id
            bld_num
            apt_id
            customer_name
            customer_family
            customer_mobile
            receiver_name
            receiver_family
            receiver_mobile
            receiver_address
            post_code
            national_identity_number
            email
            orderItems {
                id
                selling_price
                discount
                warranty_title
                size_title
                color_title
                color_hexCode
                quantity
                variant
                category_name
                category_secondName
                product {
                    id
                    code
                    mainImageUrl
                    persianTitle
                    englishTitle
                }
            }
            transactions {
                id
                amount
                paymentDate
                status
                bankName
                traceCode
            }    
          }
        }
      `,
      variables: {
        orderCode: parseInt(orderCode)
      }
    };
    fetch(process.env.REACT_APP_BACKEND_URL + "/graphql", {
      method: 'POST',
      headers: {
        Authorization: 'Bearer ' + this.props.token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(graphqlQuery)
    })
      .then(res => {
        return res.json();
      })
      .then(resData => {
        console.log(resData);
        if (resData.errors) {
          throw new Error('Fetching order failed!');
        }        
        this.setState({
          loadedOrderDetail: resData.data.order,
          orderDetailLoading: false,
        });
      })
      .catch(err => {
        console.log(err);
      });
  }

  toggleSection = () => {
    this.setState({
      minmaxdetail: this.state.minmaxdetail === true ? false : true,
    });
  }

  toggleActiveTab = () => {
    this.setState({
      activeTab: this.state.activeTab === true ? false : true,
    });
  }

  render() {
    return (
      <Fragment>
        <ErrorHandler error={this.state.error} onHandle={this.errorHandler} />
        <MessageHandler
          showMessage={this.state.showMessage}
          onHandle={this.onCancelProductHandler}
          message={
            "آیا می‌خواهید " +
            this.state.label +
            ' کالایی "' +
            this.state.title +
            '" را حذف کنید؟'
          }
          onCancelModal={this.onCancelProductHandler}
          onAcceptModal={this.onDeleteProductTypeDicisionHandler}
          acceptMessage="تایید"
          cancelMessage="لغو"
        />
        <Content>
            <ContentHeader
              headerAction="جزئیات سفارش"
              headerDescription="برای مشادهده جزئیات سفارش از این قسمت استفاده نمایید"
            />
            <div className="c-order-history__body mn-grid__row--table">
            <Card>
              
                <div className=" c-card__wrapper">
                  <div className="mn-card__header">
                    <span className="mn-promo-report__header-card-bold-title_order">جزئیات سفارش</span>
                  </div>

                  <div className="c-card__body c-card__body--form">                
                    <div className="mn-grid__row c-RD-profile__aife">
                      <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--lg-4">
                        <div className="c-form">
                          <label className="c-RD-profile__input-name" for="training_status">وضعیت سفارش</label>
                          <div className="c-RD-profile__contract-status c-RD-profile__contract-status--confirmed js-passed-traning" data-show="{trainingStatus : finished}"> پرداخت کامل انجام شده </div>
                          <div className="c-RD-profile__contract-status c-RD-profile__contract-status--pending js-passed-traning" data-show="{trainingStatus : subscribed}" style={{display: "none"}}> شرکت نکرده اید </div>
                          <div className="c-RD-profile__contract-status c-RD-profile__contract-status--rejected js-rejected-traning" data-show="{trainingStatus : new}" style={{display: "none"}}>
                            <span className="uk-text-nowrap"> ثبت‌نام نکرده‌اید </span>
                            <div className="uk-width-1-1 uk-text-left">
                              <span className="c-RD-profile__contract-tool-tip js-dropdown-desc"></span>
                              <div className="c-rating-chart__description-tooltip uk-dropdown" uk-dropdown="boundary: .js-dropdown-desc; pos: bottom-center"> در صورت عدم گذراندن دوره آموزشی، برخی از امکانات پنل برای شما غیرفعال خواهد بود. </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mn-grid__col mn-grid__col--sm-6 mn-grid__col--lg-6">
                        <div className="c-RD-profile__action-btn c-RD-profile__action-btn--outline c-RD-profile__asfe js-enroll-training " data-show="{trainingStatus : new}" style={{display: "none"}}>ثبت نام دوره آموزشی</div>
                      </div>
                    </div>
                    <div className="mn-grid__row">
                      <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--lg-4">
                        <div className="c-form">
                          <label className="c-RD-profile__input-name" for="seller-code">کد سفارش</label>
                          <div className="mn-ui-input ">
                            <input type="text" name="" className="mn-ui-input__field mn-ui-input__RD-field" id="seller-code" value={this.state.loadedOrderDetail.code} readonly="" tabindex="-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--lg-4">
                        <div className="c-form">
                          <label className="c-RD-profile__input-name" for="seller-type">تاریخ سفارش</label>
                          <div className="mn-ui-input ">
                            <input type="text" name="" className="mn-ui-input__field mn-ui-input__RD-field" id="seller-type" value={dateTimeOnlyReadable(this.state.loadedOrderDetail.order_date)} readonly="" tabindex="-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--lg-4">
                        <div className="c-form">
                          <div data-show="{sellerType:business}" style={{display: "none"}}>
                            <label className="c-RD-profile__input-name" for="seller-last-name">نوعشرکت</label>
                            <select className="mn-ui-select mn-ui-select--common mn-ui-select--small c-RD-profile js-profile-business-company-type-select select2-hidden-accessible" name="businessInfo[companyType]" id="businessInfo[companyType]" disabled="" data-no-access="{registerStatus : approved}" placeholder="انتخاب" data-select2-id="businessInfo[companyType]" tabindex="-1" aria-hidden="true"></select>
                            <span className="select2 select2-container select2-container--default select2-container--disabled" dir="rtl" data-select2-id="488" style={{width: "auto"}}>
                              <span className="selection">
                                <span className="select2-selection select2-selection--single" role="combobox" aria-haspopup="true" aria-expanded="false" tabindex="-1" aria-labelledby="select2-businessInfocompanyType-container">
                                  <span className="select2-selection__rendered" id="select2-businessInfocompanyType-container" role="textbox" aria-readonly="true"></span>
                                  <span className="select2-selection__arrow" role="presentation">
                                    <b role="presentation"></b>
                                  </span>
                                </span>
                              </span>
                              <span className="dropdown-wrapper" aria-hidden="true"></span>
                            </span>
                          </div>
                          <div data-show="{sellerType:private}" style={{display: "none"}}>
                            <label className="c-RD-profile__input-name" for="seller-business-name">نامتجاری</label>
                            <div className="mn-ui-input ">
                              <input type="text" name="businessInfo[businessName]" className="mn-ui-input__field mn-ui-input__RD-field" id="seller-business-name" value="آماتیس پارس" data-no-access="{registerStatus : approved}" readonly="" tabindex="-1"/>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mn-grid__row">
                      <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--lg-4">
                        <div className="c-form">
                          <div data-show="{sellerType:private}">
                            <label className="c-RD-profile__input-name" for="seller-first-name">نام خریدار</label>
                            <div className="mn-ui-input ">
                              <input type="text" name="businessInfo[firstName]" className="mn-ui-input__field mn-ui-input__RD-field" id="seller-first-name" value={this.state.loadedOrderDetail.customer_name} data-no-access="{registerStatus : approved}" readonly="" tabindex="-1"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--lg-4">
                        <div className="c-form">
                          <div data-show="{sellerType:private}">
                            <label className="c-RD-profile__input-name" for="seller-last-name">نام خانوادگی خریدار</label>
                            <div className="mn-ui-input ">
                              <input type="text" name="businessInfo[lastName]" className="mn-ui-input__field mn-ui-input__RD-field" id="seller-last-name" value={this.state.loadedOrderDetail.customer_family} data-no-access="{registerStatus : approved}" readonly="" tabindex="-1"/>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--lg-4">
                        <div className="c-form">
                           <div data-show="{sellerType:private}">
                            <label className="c-RD-profile__input-name" for="seller-last-name">موبایل خریدار</label>
                            <div className="mn-ui-input ">
                              <input type="text" name="businessInfo[lastName]" className="mn-ui-input__field mn-ui-input__RD-field" id="seller-last-name" value={this.state.loadedOrderDetail.customer_mobile} data-no-access="{registerStatus : approved}" readonly="" tabindex="-1"/>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div className="mn-grid__row">
                      <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--lg-4">
                        <div className="c-form">
                          <label className="c-RD-profile__input-name" for="seller-code">کد ملی خریدار</label>
                          <div className="mn-ui-input ">
                            <input type="text" name="" className="mn-ui-input__field mn-ui-input__RD-field" id="seller-code" value={this.state.loadedOrderDetail.national_identity_number} readonly="" tabindex="-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--lg-4">
                        <div className="c-form">
                          <label className="c-RD-profile__input-name" for="seller-type">ایمیل خریدار</label>
                          <div className="mn-ui-input ">
                            <input type="text" name="" className="mn-ui-input__field mn-ui-input__RD-field" id="seller-type" value={this.state.loadedOrderDetail.email} readonly="" tabindex="-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--lg-4">
                        <div className="c-form">
                           <div data-show="{sellerType:private}" style={{display: "none"}}>
                            <label className="c-RD-profile__input-name" for="seller-last-name">موبایل خریدار</label>
                            <div className="mn-ui-input ">
                              <input type="text" name="businessInfo[lastName]" className="mn-ui-input__field mn-ui-input__RD-field" id="seller-last-name" value={this.state.loadedOrderDetail.customer_mobile} data-no-access="{registerStatus : approved}" readonly="" tabindex="-1"/>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="c-RD-profile__separator"></div> */}

                    <div className="c-ship-by-seller__tabs o-spacing-m-t-4 o-spacing-m-b-4 c-grid__row">
                      <a className={[ "c-ship-by-seller__tab-option", this.state.activeTab ? "c-ship-by-seller__tab-option--active" : "" ].join(" ")} onClick={this.toggleActiveTab.bind(this)}>اطلاعات دریافت کننده</a>
                      <a className={[ "c-ship-by-seller__tab-option", this.state.activeTab ? "" : "c-ship-by-seller__tab-option--active" ].join(" ")} onClick={this.toggleActiveTab.bind(this)}>اطلاعات پرداخت</a>
                    </div>

                    <div className={[ "c-grid__row c-RD-profile--mt-40", this.state.activeTab ? "" : "uk-hidden" ].join(" ")} onClick={this.toggleActiveTab.bind(this)}>
                      <div className="mn-grid__row">
                        <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--lg-4">
                          <div className="c-form">
                            <div data-show="{sellerType:private}">
                              <label className="c-RD-profile__input-name" for="seller-first-name">نام دریافت کننده</label>
                              <div className="mn-ui-input ">
                                <input type="text" name="businessInfo[firstName]" className="mn-ui-input__field mn-ui-input__RD-field" id="seller-first-name" value={this.state.loadedOrderDetail.receiver_name} data-no-access="{registerStatus : approved}" readonly="" tabindex="-1"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--lg-4">
                          <div className="c-form">
                            <div data-show="{sellerType:private}">
                              <label className="c-RD-profile__input-name" for="seller-last-name">نام خانوادگی دریافت کننده</label>
                              <div className="mn-ui-input ">
                                <input type="text" name="businessInfo[lastName]" className="mn-ui-input__field mn-ui-input__RD-field" id="seller-last-name" value={this.state.loadedOrderDetail.receiver_family} data-no-access="{registerStatus : approved}" readonly="" tabindex="-1"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--lg-4">
                          <div className="c-form">
                            <div data-show="{sellerType:private}">
                              <label className="c-RD-profile__input-name" for="seller-last-name">موبایل دریافت کننده</label>
                              <div className="mn-ui-input ">
                                <input type="text" name="businessInfo[lastName]" className="mn-ui-input__field mn-ui-input__RD-field" id="seller-last-name" value={this.state.loadedOrderDetail.receiver_mobile} data-no-access="{registerStatus : approved}" readonly="" tabindex="-1"/>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mn-grid__row">
                        <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--lg-4" data-show="{sellerType:private}">
                          <div className="c-form">
                            <label className="c-RD-profile__input-name">استان</label>
                            <div className="mn-ui-input ">
                              <input type="text" name="businessInfo[birthDate]" className="mn-ui-input__field mn-ui-input__RD-field js-profile-business-info-birth-date pwt-datepicker-input-element" value={this.state.loadedOrderDetail.state_id} data-no-access="{registerStatus : approved}" readonly="" tabindex="-1"/>
                            </div>
                          </div>
                        </div>
                        <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--lg-4">
                          <div className="c-form">
                            <div data-show="{sellerType:private}">
                              <label className="c-RD-profile__input-name" for="national-id-number">شهر</label>
                              <div className="mn-ui-input ">
                                <input type="text" name="businessInfo[nationalIdentityNumber]" className="mn-ui-input__field mn-ui-input__RD-field" id="national-id-number" value={this.state.loadedOrderDetail.city_id} minlength="10" maxlength="10" data-no-access="{registerStatus : approved}" readonly="" tabindex="-1"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--lg-4">
                          <div className="c-form">
                            <div data-show="{sellerType:private}">
                              <label className="c-RD-profile__input-name" for="seller-last-name">کد پستی</label>
                              <div className="mn-ui-input ">
                                <input type="text" name="businessInfo[lastName]" className="mn-ui-input__field mn-ui-input__RD-field" id="seller-last-name" value={this.state.loadedOrderDetail.post_code} data-no-access="{registerStatus : approved}" readonly="" tabindex="-1"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                      </div>

                      

                      <div className="mn-grid__row_address">
                        {/* <div className="mn-ui-form__row mn-ui-form__row--extra-gap c-RD-profile--mt-20">
                          <div className="uk-flex uk-flex-left mn-ui-form__col mn-ui-form__col--6 mn-ui-form__col--xs-12">
                            <div className="c-RD-profile__gray-title">
                              <span className="c-RD-profile__title c-RD-profile--w-fc js-profile-contact-warehouse-title-0">منزل</span>
                            </div>
                            <div className="mn-ui-form__col mn-ui-form__col--wrap-xs mn-ui-form__col--pull-left uk-margin-remove-right uk-hidden">
                              <div className="c-RD-profile__delete-warehouse c-RD-profile__delete-warehouse--danger js-profile-delete-warehouse" data-id="0" data-name="منزل" data-row="1"></div>
                            </div>
                          </div>
                          <div className="mn-ui-form__col mn-ui-form__col--6 mn-ui-form__col--xs-12 mn-ui-form__col--wrap-xs c-RD-profile__center-end">
                            <label className="mn-ui-form__label c-RD-profile--ml-12 c-RD-profile--mb-0">انبار مرجوعی</label>
                            <div className="mn-ui-toggle__group">
                              <label className="mn-ui-toggle">
                                <input className="mn-ui-toggle__origin js-profile-warehouse-retrun-button-0" type="checkbox" name="contactInfo[warehouses.return_address#0]" value="1" id="contactInfo[warehouses.return_address#0]" readonly="" tabindex="-1" disabled="" checked="checked"/>
                                <span className="mn-ui-toggle__check"></span>
                              </label>
                            </div>
                          </div>
                        </div> */}
                        
                        <div className="mn-ui-form__row mn-ui-form__row--extra-gap">
                          <div className="mn-ui-form__col mn-ui-form__col--11">
                            <label className="c-RD-profile__input-name" for="contactInfo[warehouses.address#0]">آدرس دریافت کننده</label>
                            <div className="mn-ui-form__row mn-ui-form__row--group mn-ui-form__row--nowrap mn-ui-form__row--wrap-xs">
                              <div className="mn-ui-form__col mn-ui-form__col--12 mn-ui-form__col--group-item  mn-ui-form__col--shrink">
                                <div className="mn-ui-input ">
                                  <input type="text" name="contactInfo[warehouses.address#0]" className="mn-ui-input__field mn-ui-input__RD-field" id="contactInfo[warehouses.address#0]" value={this.state.loadedOrderDetail.receiver_address} readonly="" tabindex="-1"/>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                      </div>


                      <div className="mn-grid__row">
                        <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--lg-4">
                          <div className="c-form">
                            <div data-show="{sellerType:private}">
                              <label className="c-RD-profile__input-name" for="seller-first-name">پلاک</label>
                              <div className="mn-ui-input ">
                                <input type="text" name="businessInfo[firstName]" className="mn-ui-input__field mn-ui-input__RD-field" id="seller-first-name" value={this.state.loadedOrderDetail.bld_num} data-no-access="{registerStatus : approved}" readonly="" tabindex="-1"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--lg-4">
                          <div className="c-form">
                            <div data-show="{sellerType:private}">
                              <label className="c-RD-profile__input-name" for="seller-last-name">واحد</label>
                              <div className="mn-ui-input ">
                                <input type="text" name="businessInfo[lastName]" className="mn-ui-input__field mn-ui-input__RD-field" id="seller-last-name" value={this.state.loadedOrderDetail.apt_id} data-no-access="{registerStatus : approved}" readonly="" tabindex="-1"/>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mn-grid__col mn-grid__col--sm-4 mn-grid__col--lg-4">
                          <div className="c-form">
                            <div data-show="{sellerType:private}">
                              <label className="c-RD-profile__input-name" for="identity-card-number">موقعیت مکانی</label>
                              <div className="mn-ui-input ">
                                <input type="text" name="contactInfo[warehouses.legal_coordinates#0]" className="mn-ui-input__field mn-ui-input__RD-field accept-only-digits js-coordinates-input" id="contactInfo[warehouses.legal_coordinates#0]" value={this.state.loadedOrderDetail.lat +':'+this.state.loadedOrderDetail.lng} tabindex="-1" data-exceptions="9" style={{paddingLeft: "44px"}} readonly=""/>
                                <div className="mn-ui-input__RD-icon mn-ui-input__RD-icon--hh c-RD-profile--latandlong js-coordinates-btn"></div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className={[ "c-grid__row c-RD-profile--mt-40", this.state.activeTab ? "uk-hidden" : "" ].join(" ")} onClick={this.toggleActiveTab.bind(this)}>
                      
                      <table className="c-order-history__item-inner-table">
                        <thead className="c-order-history__inner-table-header" style={{width: "100% !important"}}>
                          <tr className="uk-flex">
                            <th className="c-order-transaction__row"> ردیف </th>
                            <th className="c-order-transaction__unit-price"> قیمت واحد (ریال) </th>
                            <th className="c-order-transaction__date"> تاریخ تراکنش </th>
                            <th className="c-order-transaction__time"> ساعت تراکنش </th>
                            <th className="c-order-transaction__status"> وضعيت تراکنش </th>
                            <th className="c-order-transaction__gate"> درگاه پرداخت </th>
                            <th className="c-order-transaction__trace"> کد پیگیری </th>
                          </tr>
                        </thead>
                        <tbody className="uk-flex uk-flex-column">
                          {this.state.loadedOrderDetail.transactions && this.state.loadedOrderDetail.transactions.map((transaction, index) => (
                          <tr className="c-order-history__inner-row" style={{zIndex: "2"}}>
                            <td className="c-order-transaction__td__row">{index+1}</td>
                            <td className="c-order-transaction__td__unit-price">
                              <span dir="ltr"> {String(transaction.amount).replace(/(.)(?=(\d{3})+$)/g,'$1,')} </span>
                            </td>
                            <td className="c-order-transaction__td__date c-order-history__inner-column">
                              <span>
                                <span >{dateOnlyReadable(transaction.paymentDate)}</span>
                              </span>
                            </td>
                            <td className="c-order-transaction__td__time c-order-history__inner-column">
                              <span>
                                <span dir="ltr">{transaction.paymentDate.split(', ')[1]}</span>
                              </span>
                            </td>
                            <td className="c-order-transaction__td__status c-order-history__inner-column">
                                  {transaction.status==7?<span className="c-ui-order-status c-ui-order-status--purchased"> موفق </span>:<span className="c-ui-order-status c-ui-order-status--returned"> ناموفق </span>}
                            </td>
                            <td className="c-order-transaction__td__gate c-order-history__inner-column">
                              <span> {transaction.bankName} </span>
                            </td>
                            <td className="c-order-transaction__td__trace c-order-history__inner-column">
                              <span> {transaction.traceCode} </span>
                            </td>
                            <td className="c-order-transaction__last-col js-p-rd-tooltip" style={{position: "relative", zIndex: "10000 !important"}}>
                              
                            </td>
                          </tr>))}
                        </tbody>
                      </table>
                          

                
                
                
                
                    </div>

                    
                    
                    
                    
                    <div className="c-RD-profile__profile-modal-warninig uk-flex uk-width-1-1 uk-hidden">
                      <span className="c-RD-profile__alert-icon"></span>
                      <p> فروشنده گرامی، لطفاً در بخش بارگذاری مدارک، گواهی مالیات بر ارزش افزوده خود را بارگذاری کنید. </p>
                    </div>

                    <div className="mn-grid__row uk-margin-medium-top uk-hidden" id="logoCriteria">
                      <div className="c-profile-business-info-logo-hint"> شرایط لوگو: ۱- پس‌زمینه ترجیحا سفید باشد ۲- قالب مربع ۲- حداقل ۶۰۰ در ۶۰۰ پیکسل ۴- فرمت PNG یا JPG </div>
                      <div className="c-profile-business-info-logo-hint"> متن پیشنهادی را با توجه به نکات زیر ارسال کنید: <br/> • شرح حال کسب‌ و کارتان را در خصوص تاریخچه، تنوع و محصولاتتان بین 100 تا 150 کلمه یادداشت کنید. <br/> • حتما به سال شروع فعالیتتان در متن ارسالی اشاره کنید. <br/> • متن ارسالی باید فاقد آدرس سایت و صفحات مجازی هرگونه شماره تماس باشد </div>
                    </div>

                    
                  </div>

                  <div className="c-RD-profile__separator"></div>

                  <div className="c-card__body c-ui-table__wrapper_product">
                    <table className="c-ui-table   js-search-table js-table-fixed-header">
                      <thead>
                        <tr className="c-ui-table__row">
                          <th className="c-ui-table__header c-ui-table__header--nowrap ">
                            <span className="js-search-table-column">ردیف</span>
                          </th>
                          {/* <th className="c-ui-table__header c-ui-table__header--nowrap ">
                            <span className="js-search-table-column">وضعیت سفارش</span>
                          </th> */}
                          <th className="c-ui-table__header c-ui-table__header--nowrap ">
                            <span className="js-search-table-column">تصویر کالا</span>
                          </th>
                          <th className="c-ui-table__header c-ui-table__header--nowrap ">
                            <span className="js-search-table-column">عنوان و کد تنوع (SHPC)</span>
                          </th>
                          <th className="c-ui-table__header c-ui-table__header--nowrap ">
                            <span className="js-search-table-column">تعداد</span>
                          </th>
                          <th className="c-ui-table__header c-ui-table__header--nowrap ">
                            <span className="js-search-table-column-sortable table-header-searchable">کد محصول</span>
                          </th>
                          <th className="c-ui-table__header c-ui-table__header--nowrap ">
                            <span className="js-search-table-column-sortable table-header-searchable">کد تنوع</span>
                          </th>
                          <th className="c-ui-table__header c-ui-table__header--nowrap ">
                            <span className="js-search-table-column">قیمت / تخفیف</span>
                          </th>
                          <th className="c-ui-table__header c-ui-table__header--nowrap ">
                            <span className="js-search-table-column">گروه کالایی</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loadedOrderDetail.orderItems && this.state.loadedOrderDetail.orderItems.map((orderItem, index) => (
                        <tr className={[ "c-order-history__item-header", this.state.minmaxdetail ? "" : "c-order-history__item-header--minimized" ].join(" ")}>
                          <td className="c-order-history__item-index_row"> {index+1} </td>
                          {/* <td className="c-order-history__status_status uk-flex">
                            <span className="c-ui-order-status c-ui-order-status--purchased"> فروش </span>
                          </td> */}
                          <td className="c-order-history__splitter"></td>
                          <td className="c-order-history__item-image_image">
                            <img src={'https://api.shirazpc.com/'+orderItem.product.mainImageUrl} alt="" className=""/>
                          </td>
                          <td className="c-order-history__item-title"> {orderItem.product.persianTitle} | {orderItem.size_title!==null ? orderItem.size_title : orderItem.color_title!==null ? orderItem.color_title : ''} | {orderItem.warranty_title} <div className="c-order-history__variant-tag"> SHP-{orderItem.product.code} </div>
                          </td>
                          <td className="c-order-history__create-date_quantity"> {orderItem.quantity} </td>
                          <td className="c-order-history__product-id_data">
                            <a href="https://www.digikala.com/product/dkp-15504/"> {orderItem.product.code} </a>
                          </td>
                          <td className="c-order-history__seller-id_data">{orderItem.variant}</td>
                          <td className="c-order-history__package-codes_price c-order-history__inner-column">
                            <span> {orderItem.selling_price} </span>
                            <span> {orderItem.discount} </span>
                          </td>
                          <td className="c-order-history__category_data"> {orderItem.category_secondName!==""?(orderItem.category_name+" ("+orderItem.category_secondName+")"):orderItem.category_name} </td>
                          {/* <td className="c-order-history__last-column">
                            <button className={[ "js-order-history-minimize-item", this.state.minmaxdetail ? "c-order-history__maximize-button" : "c-order-history__minimize-button " ].join(" ")} onClick={this.toggleSection.bind(this)}></button>
                          </td> */}
                        </tr>))}
                        {/* <tr className={[ "c-order-history__item-body", this.state.minmaxdetail ? "" : "c-order-history__item-body--minimized" ].join(" ")}>
                          <td>
                            <table className="c-order-history__item-inner-table">
                              <thead className="c-order-history__inner-table-header" style={{width: "100% !important"}}>
                                <tr className="uk-flex">
                                  <th className="c-order-history__serial-number"> سریال کالا </th>
                                  <th className="c-order-history__"></th>
                                  <th className="c-order-history__delivery-from"> ارسال توسط </th>
                                  <th className="c-order-history__from-warehouse"> تامین از انبار </th>
                                  <th className="c-order-history__interval"> بازه ارسال </th>
                                  <th className="c-order-history__to-customer"> خروج از انبار / ارسال به مشتری </th>
                                  <th className="c-order-history__return-date"> ورود مجدد به انبار/ مرجوع به فروشنده </th>
                                  <th className="c-order-history__unit-price"> قیمت واحد (ریال) </th>
                                  <th className="c-order-history__discount"> تخفیف واحد (ریال) </th>
                                  <th className="c-order-history__discount-type"> نوع تخفیف </th>
                                  <th className="c-order-history__commission"> هزینه تبلیغ(ریال) </th>
                                  <th className="c-order-history__commission"> کمیسیون تبلیغ (ریال) </th>
                                </tr>
                              </thead>
                              <tbody className="uk-flex uk-flex-column">
                                <tr className="c-order-history__inner-row" style={{zIndex: "2"}}>
                                  <td className="c-order-history__serial-number "> CEA7823D </td>
                                  <td className="c-order-history__delivery-from c-order-history__inner-column">
                                    <button id="" className="c-ui-btn-shipment-by c-ui-btn-shipment-by--dk " disabled=""></button>
                                  </td>
                                  <td className="c-order-history__from-warehouse c-order-history__inner-column">
                                    <button id="" className="c-ui-btn-shipment-by c-ui-btn-shipment-by--dk " disabled=""></button>
                                  </td>
                                  <td className="c-order-history__interval"> ۲ </td>
                                  <td className="c-order-history__to-customer"> ۱۴۰۰/۰۹/۰۳ ۱۲:۳۰ </td>
                                  <td className="c-order-history__return-date"></td>
                                  <td className="c-order-history__unit-price">
                                    <span dir="ltr" data-debug="۳۷۵۰۰۰۰۰">۳۷,۵۰۰,۰۰۰</span>
                                  </td>
                                  <td className="c-order-history__discount c-order-history__inner-column">
                                    <span>
                                      <span dir="ltr" data-debug="۰">۰</span>
                                    </span>
                                  </td>
                                  <td className="c-order-history__discount-type c-order-history__inner-column">
                                    <span> بدون تخفیف </span>
                                  </td>
                                  <td className="c-order-history__commission c-order-history__inner-column">
                                    <span> - </span>
                                  </td>
                                  <td className="c-order-history__commission c-order-history__inner-column">
                                    <span> - </span>
                                  </td>
                                  <td className="c-order-history__last-col js-p-rd-tooltip" style={{position: "relative", zIndex: "10000 !important"}} data-serial-id=""></td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr> */}
                      </tbody>
                    </table>
                  </div>
                  <div className="c-card__footer">
                    
                  </div>
                  {/* <div className="c-card__loading">
                    
                  </div> */}
                  {this.state.orderDetailLoading && (
                    <div style={{ textAlign: "center", marginTop: "2rem" }}>
                      <Loader />
                    </div>
                  )}
                  

                </div>
            </Card>
          </div>           
        </Content>
      </Fragment>
    );
  }
}

export default SingleOrder;




